import styled from '@emotion/styled';
import {
  spacing,
  fontWeight,
  fontSize,
  mediaMax,
  mediaMin,
} from 'presentations/views/styles';
import MonthCalendar from 'presentations/views/components/organisms/apps/MonthCalendar';
import Link from 'presentations/views/components/atoms/Link';
import { getDateTime } from 'infras/datetime';
import { CalendarArray } from 'usecases/app_calendar';
import {
  appCalendarMonthFilterPath,
  appCalendarMonthPath,
  appCalendarPath,
} from 'presentations/routes/path';
import { black } from 'presentations/views/styles/color';

interface CalendarListProps {
  year: number;
  filter?: string;
  calendars: CalendarArray[];
}

export default function Component({
  year,
  calendars,
  filter,
}: CalendarListProps) {
  return (
    <CalendarListContainer>
      {calendars.map((weeks, i: number) => {
        const month = i + 1;
        const title = getDateTime()
          .set({ year, month })
          .toLocaleString({ month: 'long' });
        let link;
        if (filter) {
          link = appCalendarMonthFilterPath(year, month, filter);
        } else {
          link = appCalendarMonthPath(year, month);
        }

        return (
          <MonthContainer key={i}>
            <MonthTitleContainer id={`month-${month}`}>
              <MonthLink href={link}>{title}</MonthLink>
            </MonthTitleContainer>
            <MonthCalendar weeks={weeks} filter={filter} />
          </MonthContainer>
        );
      })}
    </CalendarListContainer>
  );
}
export const CalendarListContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
`;
export const MonthLink = styled(Link)`
  color: ${black};
`;
export const MonthContainer = styled.div`
  width: calc(100% / 2 - 24px);
  margin-right: ${spacing(24)};
  margin-bottom: ${spacing(48)};
  ${mediaMax.tablet} {
    width: 100%;
    margin-right: 0;
    margin-bottom: 0;
    margin-top: ${spacing(32)};
    &:first-of-type {
      margin-top: 0;
    }
    &:last-of-type {
      margin-bottom: ${spacing(32)};
    }
  }
`;
export const MonthTitleContainer = styled.h3`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(20)};
  margin-bottom: ${spacing(8)};
  ${mediaMin.tablet} {
    font-size: ${fontSize(24)};
  }
  text-align: center;
`;
